import axios, { AxiosInstance, AxiosError } from 'axios';
import type { ApiResponse } from '../types';

/**
 * Axios 实例
 * baseURL: /api（通过 Vite proxy 转发到后端 http://localhost:3000）
 */
const client: AxiosInstance = axios.create({
  baseURL: '/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * 响应拦截器
 * 统一提取 ApiResponse 中的 data
 * 错误时返回业务错误信息
 */
client.interceptors.response.use(
  (response) => {
    const apiResponse = response.data as ApiResponse;

    // 如果返回的是标准 API 响应格式
    if (apiResponse && typeof apiResponse.code !== 'undefined') {
      if (apiResponse.code !== 0) {
        // 业务错误
        return Promise.reject(new Error(apiResponse.message || '请求失败'));
      }
      // 成功：直接返回 data 字段
      return { ...response, data: apiResponse.data };
    }

    // 非标准格式，直接返回
    return response;
  },
  (error: AxiosError) => {
    if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
      return Promise.reject(new Error('请求超时，请稍后重试'));
    }
    if (error.response) {
      const apiResponse = error.response.data as ApiResponse | undefined;
      const message = apiResponse?.message || `服务器错误 (${error.response.status})`;
      return Promise.reject(new Error(message));
    }
    if (error.request) {
      return Promise.reject(new Error('网络请求失败，请检查后端服务是否启动'));
    }
    return Promise.reject(error);
  }
);

export default client;
